import React from 'react'

import { PageSection1 } from '@guiker/react-framework'
import {
  InvestmentPerformance,
  ListingDocuments,
  OfferingDetails,
  usePropertyContext,
} from '@guiker/real-estate-components'
import { hasDocument } from '@guiker/real-estate-shared'

import { CommonQuestions, PropertyDescription, RentalDetails } from '../../../components'
import { useListingScreenContext } from '../../../context'

export const DetailsTab: React.FC = () => {
  const { listing } = useListingScreenContext()
  const { property } = usePropertyContext()
  const documents = listing?.documents.map((d) => ({
    id: d.id,
    url: d.presignedDownloadUrl,
    displayName: d.displayName,
    fileName: d.fileName,
  }))

  return (
    <PageSection1>
      <PropertyDescription />
      <InvestmentPerformance />
      <RentalDetails />
      <OfferingDetails />
      {hasDocument(property) && <ListingDocuments property={{ ...property, documents }} />}
      <CommonQuestions />
    </PageSection1>
  )
}
